$(function() {
    "use strict";

    $(document).on('ready', function() {
        var $blocks = $('.clamp-it');
        if ($blocks.length) {
            $blocks.each(function() {
                $clamp($(this).get(0), {clamp: 3});
            });
        }
    });

});
